// Turns details of a 422 broker_report.structurally_invalid into a human list (AC-04, ADR-0007).
// Identifiers contain dots (`section.field`), which i18next reads as a key separator, so the
// dictionary is fetched as a flat object and looked up by the identifier string itself.

function dictionary(t, key) {
  const value = t(key, { returnObjects: true });
  return value && typeof value === "object" ? value : {};
}

function formatMissingFields(t, details, commonMessage) {
  if (!details) return { formatLabel: "", items: [] };

  const formats = dictionary(t, "reportFields.formats");
  const fields = dictionary(t, "reportFields.fields");
  const unknown = (identifier) => (commonMessage ? `${commonMessage} (${identifier})` : identifier);

  return {
    formatLabel: formats[details.format] || details.format || "",
    items: (details.missing || []).map((identifier) => fields[identifier] || unknown(identifier)),
  };
}

export default formatMissingFields;
